import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  listNotifications,
  markAllNotificationsSeen,
  markNotificationSeen,
} from '../api/notificationsApi';
import { queryKeys } from '../query/queryKeys';

const DEFAULT_PARAMS = { page: 1, per_page: 20 };

export function useNotifications(params = DEFAULT_PARAMS) {
  return useQuery({
    queryKey: queryKeys.notifications.list(params),
    queryFn: async () => {
      const res = await listNotifications(params);
      return res.data?.data ?? { items: [], unread: 0 };
    },
    staleTime: 30 * 1000,
  });
}

export function useMarkNotificationSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markNotificationSeen,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.all });
    },
  });
}

export function useMarkAllNotificationsSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markAllNotificationsSeen,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.all });
    },
  });
}
